var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShareRed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9989 1C11.1269 1 11.2547 1.04875 11.3524 1.14625L16.3534 6.145C16.5487 6.34025 16.5487 6.65675 16.3534 6.85225C16.1587 7.0475 15.8417 7.04725 15.6464 6.85225L11.4999 2.70775L11.4999 15.5C11.4999 15.776 11.2759 16 10.9999 16C10.7237 16 10.4999 15.776 10.4999 15.5L10.4999 2.706L6.35343 6.85225C6.15818 7.0475 5.84168 7.0475 5.64643 6.85225C5.45118 6.657 5.45118 6.34025 5.64643 6.14525L10.6454 1.14625C10.7429 1.04875 10.8709 1 10.9989 1ZM20 15.5001C20 15.2241 20.224 15.0001 20.5 15.0001C20.776 15.0001 21 15.2241 21 15.5001V20.5001C21 20.7761 20.776 21.0001 20.5 21.0001H1.5C1.224 21.0001 1 20.7761 1 20.5001V15.5001C1 15.2241 1.224 15.0001 1.5 15.0001C1.776 15.0001 2 15.2241 2 15.5001V20.0001H20V15.5001Z",
    fill: "#E81111"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShareRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Share-red.fd757173c492adf54cbcb15f0c8fae57.svg";